var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAgeScan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.00054 9.16612C10.0803 9.16612 10.6876 8.55879 10.6876 7.47906C10.6876 6.39934 10.0803 5.79199 9.00054 5.79199C7.92081 5.79199 7.31348 6.39934 7.31348 7.47906C7.31348 8.55879 7.92081 9.16612 9.00054 9.16612Z",
    stroke: "black",
    strokeWidth: 1.29,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4977 11.8998C11.749 10.4482 10.5432 9.16553 9.00034 9.16553C7.45745 9.16553 6.25168 10.4482 6.50299 11.8998C6.56755 12.2727 6.63683 12.6379 6.70832 12.9615C6.89178 13.7916 7.20403 14.8636 7.4467 15.6564C7.64779 16.3134 8.28255 16.7573 9.00034 16.7573C9.71811 16.7573 10.3529 16.3134 10.554 15.6564C10.7966 14.8636 11.1089 13.7916 11.2923 12.9615C11.3638 12.6379 11.4331 12.2727 11.4977 11.8998Z",
    stroke: "black",
    strokeWidth: 1.29,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.42024 16.7584C4.43765 16.7584 3.56208 16.1129 3.36236 15.1306C3.13908 14.0324 2.96857 12.7933 2.83909 11.5907H2.42453C1.69851 11.5907 1.11977 10.9563 1.26452 10.232C1.4133 9.48757 1.6346 8.77786 1.93223 8.08634C2.51876 6.72358 3.94809 6.01944 5.40933 6.01614C5.41296 6.01613 5.4166 6.01611 5.42024 6.01611C5.42459 6.01611 5.42895 6.01613 5.43331 6.01614",
    stroke: "black",
    strokeWidth: 1.29,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.80651 3.62884C7.80651 2.10107 6.94714 1.2417 5.41937 1.2417C3.8916 1.2417 3.03223 2.10107 3.03223 3.62884C3.03223 5.15661 3.8916 6.01599 5.41937 6.01599",
    stroke: "black",
    strokeWidth: 1.29,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5815 6.01611C14.1702 6.01611 15.0915 6.96349 15.7463 8.26375C16.0893 8.94482 16.4978 11.0866 16.7438 12.619C16.8574 13.3264 16.3218 13.9526 15.6242 13.9526H14.922C14.5026 15.2152 14.2041 16.7583 12.5791 16.7583",
    stroke: "black",
    strokeWidth: 1.29,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5815 6.01599C14.1093 6.01599 14.9686 5.15661 14.9686 3.62884C14.9686 2.10107 14.1093 1.2417 12.5815 1.2417C11.0537 1.2417 10.1943 2.10107 10.1943 3.62884",
    stroke: "black",
    strokeWidth: 1.29,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgeScan);
export default __webpack_public_path__ + "static/media/age_scan.afb83886148ad1a03db97b351774f5ec.svg";
export { ForwardRef as ReactComponent };